<template>
  <div class="space-y-4">
    <h3>
      {{ t('agency') }}
    </h3>

    <div class="grid gap-4 md:grid-cols-3">
      <LabeledText :label="t('company')">{{ agency.company ?? '-' }}</LabeledText>
      <LabeledText :label="t('name')"> {{ agency.firstName }} {{ agency.lastName }} </LabeledText>
      <LabeledText :label="t('email')">{{ agency.email }}</LabeledText>
    </div>
  </div>
</template>

<script lang="ts" setup>
import LabeledText from '@/components/LabeledText.vue';
import type { User } from '@/entities/auth/user.entity';
import { useI18n } from 'vue-i18n';

defineProps<{
  agency: User;
}>();

const { t } = useI18n();
</script>

<i18n lang="json">
{
  "en": {
    "agency": "Agency",
    "company": "Company",
    "name": "Name",
    "email": "Email"
  },
  "de": {
    "agency": "Vermittler",
    "company": "Firma",
    "name": "Name",
    "email": "Email"
  },
  "es": {
    "agency": "Agencia",
    "company": "Empresa",
    "name": "Nombre",
    "email": "Correo electrónico"
  }
}
</i18n>
